module.exports = __webpack_public_path__ + "static/media/vision.572d74e3.png";